import gql from 'graphql-tag';
import * as Urql from 'urql';

import * as Types from './types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SearchReefersByIdQueryVariables = Types.Exact<{
  search: Types.Scalars['String']['input'];
}>;

export type SearchReefersByIdQuery = {
  __typename?: 'query_root';
  container_insights_reefers: Array<{
    __typename?: 'container_insights_reefers';
    id: string;
    refrigeration_unit_model: {
      __typename?: 'container_insights_refrigeration_unit_models';
      id: any;
      name: string;
      manufacturer: {
        __typename?: 'container_insights_manufacturers';
        id: any;
        name: string;
      };
    };
    shipping_line: {
      __typename?: 'container_insights_shipping_lines';
      id: any;
      name: string;
    };
  }>;
};

export const SearchReefersByIdDocument = gql`
  query SearchReefersById($search: String!) {
    container_insights_reefers(
      where: { id: { _ilike: $search } }
      order_by: { id: asc }
    ) {
      id
      refrigeration_unit_model {
        id
        name
        manufacturer {
          id
          name
        }
      }
      shipping_line {
        id
        name
      }
    }
  }
`;

export function useSearchReefersByIdQuery(
  options: Omit<Urql.UseQueryArgs<SearchReefersByIdQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SearchReefersByIdQuery, SearchReefersByIdQueryVariables>(
    { query: SearchReefersByIdDocument, ...options },
  );
}
